import { DeviceTabletSvgIcon } from './svg';
import { makeIcon } from './make-icon';

export const DeviceTabletIcon = makeIcon(
  DeviceTabletSvgIcon,
  'DeviceTabletIcon',
)`
  position: relative;
  top: 0.1em;

  rect {
    stroke: currentColor;
  }
  circle {
    fill: currentColor;
  }
`;
